import { Component, Host, Prop, h } from '@stencil/core';

import dynamicEntryActions from '../../../actions/actions.dynamic-entry';
import { shiftDigitalTradeInStart } from '../../../tracking/tracking.dynamic-entry';
import { YMM_ERRORS, mapSuggestionsToValue } from '../../../utils/utils.dynamic-entry';
import { DynamicEntryStartButton } from '../DynamicEntryStartButton';

@Component({
  tag: 'dynamic-ymm-entry',
  styleUrl: 'dynamic-ymm-entry.css',
})
export class DynamicYmmEntry {
  @Prop() ymmSuggestions = [];
  @Prop() value: string = '';
  @Prop() vehicleId: number = 0;
  @Prop() hasError: boolean = false;
  @Prop() isPrimaryInput: boolean = true;
  @Prop() isFetching: boolean = false;
  @Prop() isDisabled: boolean = false;

  async handleSubmit() {
    await dynamicEntryActions.onFindByYmm(this.isPrimaryInput);
  }

  handleYmmChange(event: CustomEvent) {
    const inputYmm = event.detail;
    dynamicEntryActions.onGetYmmSuggestions(inputYmm);
  }

  onSuggestionClick(vehicleId: number) {
    dynamicEntryActions.onYmmSelected(vehicleId);
  }

  componentDidRender() {
    // timeout ensures smooth transition between loader and content
    setTimeout(() => {
      dynamicEntryActions.onStoreUpdate({ isTabRendering: false });
    }, 200);
  }

  onInputFocus() {
    shiftDigitalTradeInStart();
  }

  render() {
    return (
      <Host>
        <div class="flex gap-x-5 gap-y-2 flex-col mt-4">
          <div class="basis-2/3">
            <input-textbox-autocomplete
              testId="ymm-model"
              placeholder="Enter Year Make and Model"
              errorMessage={YMM_ERRORS.YMM_MISSING}
              hasError={this.hasError}
              value={this.value}
              suggestions={mapSuggestionsToValue(this.ymmSuggestions)}
              whenChanged={(event: CustomEvent) => this.handleYmmChange(event)}
              whenChosen={(id: number) => {
                this.onSuggestionClick(id);
              }}
              errorHiddenMode
              prefixError="dynamic-entry"
              whenPressEnter={() => {
                if (this.value) {
                  this.handleSubmit();
                }
              }}
              onFocus={() => this.onInputFocus()}
              isDisabled={this.isDisabled}
            />
          </div>
          <p class="dynamic-ymm-entry-example-text text-xs my-1">Ex: 2019 Honda Accord EX-L Sedan 4D</p>
          <div class="w-full">
            <DynamicEntryStartButton
              data-testid="bi-btn-start-my-offer"
              whenClicked={() => this.handleSubmit()}
              isFetching={this.isFetching}
              color={this.isPrimaryInput ? 'start-action' : 'tertiary'}
              disabled={this.isDisabled}
            />
          </div>
        </div>
      </Host>
    );
  }
}
